import { isNullish } from '@caresend/utils';
import { defineComponent, ref, computed, watch } from 'vue';
import __vue_component__ from '../../inputs/EmailInput.vue.js';
import __vue_component__$1 from '../../inputs/PhoneNumberInput/PhoneNumberInput.vue.js';

const isInputEmpty = (input) => isNullish(input) || input === '';
var script = defineComponent({
    name: 'Credentials',
    components: { EmailInput: __vue_component__, PhoneNumberInput: __vue_component__$1 },
    props: {
        disabled: Boolean,
        disableEmailField: Boolean,
        infoProps: {
            type: Object,
            required: true,
        },
        isEmailOptional: Boolean,
        isPhoneOptional: Boolean,
        invalidEmails: {
            type: Array,
            default: () => [],
        },
        userID: {
            type: String,
            default: undefined,
        },
        userCanExist: Boolean,
    },
    setup(props, { emit }) {
        const phoneNumberValid = ref(false);
        const emailValid = ref(false);
        const info = ref(props.infoProps);
        const isValid = computed(() => {
            var _a;
            if (props.isEmailOptional && isInputEmpty(info.value.email)) {
                return phoneNumberValid.value;
            }
            if (props.isPhoneOptional && isInputEmpty((_a = info.value.phone) === null || _a === void 0 ? void 0 : _a.number)) {
                return emailValid.value;
            }
            return emailValid.value && phoneNumberValid.value;
        });
        const phoneNumber = computed(() => { var _a; return (_a = info.value.phone) === null || _a === void 0 ? void 0 : _a.number; });
        const countryCode = computed(() => { var _a; return (_a = info.value.phone) === null || _a === void 0 ? void 0 : _a.countryCode; });
        watch(isValid, (newIsValid) => {
            emit('input', newIsValid);
        }, { immediate: true });
        watch(info, (newInfo) => {
            emit('setInfo', newInfo);
        }, { deep: true });
        const updatedPhoneNumber = (data) => {
            info.value.phone = data.phone.number ? data.phone : undefined;
            phoneNumberValid.value = data.isValid;
        };
        const setIsEmailValid = (valid) => {
            emailValid.value = valid;
        };
        return {
            countryCode,
            info,
            phoneNumber,
            setIsEmailValid,
            updatedPhoneNumber,
        };
    },
});

export { script as default };
